
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.941 10C6.421 10 6 9.552 6 9s.421-1 .941-1H37.06c.52 0 .941.448.941 1s-.421 1-.941 1H6.94zm0 13C6.421 23 6 22.552 6 22s.421-1 .941-1H37.06c.52 0 .941.448.941 1s-.421 1-.941 1H6.94zM6.91 36c-.503 0-.91-.448-.91-1s.407-1 .91-1h18.18c.503 0 .91.448.91 1s-.407 1-.91 1H6.91z"}})])
          )
        }
      }
    